import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from "@mui/material";

export default function StoreCategoryDeleteModal({
  open,
  onClose,
  onConfirm,
  category,
  loading,
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Eliminar categoría</DialogTitle>

      <DialogContent>
        <Typography fontWeight={600}>
          {category?.name}
        </Typography>

        <Typography fontSize={13} color="#64748b">
          Solo se eliminará si no tiene productos asociados.
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>

        <Button
          onClick={onConfirm}
          variant="contained"
        >
          Eliminar
        </Button>
      </DialogActions>
    </Dialog>
  );
}